<template>
	<v-menu v-model="menu" transition="slide-y-transition" offset-y rounded="xl">
		<template v-slot:activator="{ on, attrs }">
			<v-btn icon plain v-bind="attrs" v-on="on" class="mr-2">
				<v-icon color="black">icon-bell</v-icon>
			</v-btn>
		</template>

		<v-list width="320">
			<v-list-item link :disabled="loadingShipment" @click="openLatestShipment">
				<v-list-item-content>
					<v-list-item-title>Your shipment has arrived.</v-list-item-title>
				</v-list-item-content>
				<v-list-item-action v-if="loadingShipment">
					<v-progress-circular indeterminate size="16" width="2" />
				</v-list-item-action>
			</v-list-item>

			<v-list-item link :disabled="loadingProforma" @click="openLatestProforma">
				<v-list-item-content>
					<v-list-item-title>You have a new Proforma Invoice.</v-list-item-title>
				</v-list-item-content>
				<v-list-item-action v-if="loadingProforma">
					<v-progress-circular indeterminate size="16" width="2" />
				</v-list-item-action>
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script>
import remote from "../../../data/remote";

export default {
	name: "NotificationsMenu",
	data() {
		return {
			menu: false,
			loadingShipment: false,
			loadingProforma: false,
		};
	},
	methods: {
		openLatestShipment() {
			this.loadingShipment = true;
			remote.shipments.filter({
				filter: undefined,
				pager: { number: 1, size: 1 },
				sorter: { property: "date", method: "desc" },
				onSuccess: ({ items }) => {
					const item = items?.[0];
					const id = item?.id || item?._id;
					this.menu = false;
					this.loadingShipment = false;
					if (id) this.$router.push(`/shipment/${id}`);
					else this.$router.push(`/shipments`);
				},
				onFail: () => {
					this.menu = false;
					this.loadingShipment = false;
				},
			});
		},
		openLatestProforma() {
			this.loadingProforma = true;
			remote.proformaInvoices.filter(
				{
					filter: undefined,
					pager: { number: 1, size: 1 },
					sorter: { property: "date", method: "desc" },
				},
				{
					onSuccess: ({ items }) => {
						const item = items?.[0];
						const id = item?.id || item?._id;
						this.menu = false;
						this.loadingProforma = false;
						if (id) this.$router.push(`/proforma_invoices/${id}`);
						else this.$router.push(`/proforma_invoices`);
					},
					onFail: () => {
						this.menu = false;
						this.loadingProforma = false;
					},
				}
			);
		},
	},
};
</script>
